import { Box, Theme, Tooltip, Typography } from "@material-ui/core";
import { HighlightOffRounded } from "@material-ui/icons";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import * as React from "react";

import { LoadedEventDefinition } from "../../../types/global";
import {
  RequestableSaasDestination,
  SaaSDestination,
  WarehouseDestination,
} from "../../../destinations/destinations";
import FilterEventsGroup from "./FilterEventsGroups";
import BulkEditActions from "../BulkEdit/BulkEditActions";
import { VisibilityFilterOptionValues } from "./constants";

const useStyles = makeStyles((theme: Theme) => ({
  filterHeader: {
    height: "auto",
    padding: theme.spacing(2),
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    fontSize: "1rem",
    color: "#444444",
    position: "sticky",
    top: 0,
    backgroundColor: "white",
    zIndex: 1,
    width: "100%",
  },
  headerSpacer: {
    margin: `0 ${theme.spacing(1.5)}px`,
    height: 60,
    width: 0,
  },
}));

interface FilterHeaderProps {
  totalEvents: number;
  typeFilterChoices: string[];
  destinationFilterChoices: string[];
  configurableDestinations: Record<
    string,
    | SaaSDestination
    | RequestableSaasDestination
    | WarehouseDestination
    | undefined
  >;
  tagFilterChoices: string[];
  visibilityFilterChoices: VisibilityFilterOptionValues[];
  selectedEvents: string[];
  allEvents: LoadedEventDefinition[];
  events: LoadedEventDefinition[];
  onClearSelection: () => void;
  toggleEventForwarding: (destinationId: string, checked: boolean) => void;
  searchQuery: string;
  setSearchQuery: (searchQuery: string) => void;
}

export default function FilterHeader({
  totalEvents,
  typeFilterChoices,
  tagFilterChoices,
  destinationFilterChoices,
  visibilityFilterChoices,
  configurableDestinations,
  selectedEvents,
  allEvents,
  events,
  onClearSelection,
  toggleEventForwarding,
  searchQuery,
  setSearchQuery,
}: React.PropsWithChildren<FilterHeaderProps>) {
  const classes = useStyles();

  const emptySelection = selectedEvents.length === 0;

  return (
    <Box className={clsx(classes.filterHeader)}>
      {emptySelection ? (
        <>
          <Box display="flex" alignItems="center">
            <Typography variant="body1">{totalEvents} Events</Typography>
            <Box className={clsx(classes.headerSpacer)} />
          </Box>
          <FilterEventsGroup
            allEvents={allEvents}
            typeFilterChoices={typeFilterChoices}
            tagFilterChoices={tagFilterChoices}
            visibilityFilterChoices={visibilityFilterChoices}
            destinationFilterChoices={destinationFilterChoices}
            configurableDestinations={configurableDestinations}
            setSearchQuery={setSearchQuery}
            searchQuery={searchQuery}
          />
        </>
      ) : (
        <>
          <Box display="flex" alignItems="center">
            <Typography variant="body1">
              {selectedEvents.length} Selected
            </Typography>

            <Tooltip title="Clear selection" arrow>
              <button onClick={onClearSelection}>
                <HighlightOffRounded
                  style={{
                    width: 16,
                    height: 16,
                    marginTop: -4,
                    marginLeft: 8,
                  }}
                />
              </button>
            </Tooltip>
          </Box>
          <Box className={clsx(classes.headerSpacer)} />
          <BulkEditActions
            selectedEvents={selectedEvents}
            allEvents={allEvents}
            events={events}
            onClearSelection={onClearSelection}
            toggleEventForwarding={toggleEventForwarding}
            configurableDestinations={configurableDestinations}
          />
        </>
      )}
    </Box>
  );
}
